<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="NewLandscape"
    title="New Landscape"
    submit-name="Create"
    full-height
    @submit="submit"
    @[Events.BEFORE_CLOSE]="cleanQuery"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-input ref="inputName" label="Name" focus @submit="submitFromInput()" />
    <lm-textarea
      ref="inputDescription"
      label="Description"
      @submit="submitFromInput()"
    />
    <span class="font-mono text-xxs uppercase text-gray-500">Template</span>
    <lm-template-selector
      ref="templateSelector"
      :value="template"
      highlight
      :load-images="loadTemplates"
      @select="templateSelected"
    />
  </form-modal>
</template>

<script>
import {Modal, Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import LmTextarea from '@/components/form/LmTextarea.vue'
import FormHelper from '@/components/form/formHelper'
import LmTemplateSelector from '@/components/ui/LmTemplateSelector.vue'

export default {
  name: 'ModalNewLandscape',
  components: {
    FormModal,
    LmInput,
    LmTextarea,
    LmTemplateSelector
  },
  data() {
    return {
      Events,
      modalName: Modal.NEW_LANDSCAPE,
      modalRef: null,
      inputs: null,
      landscapeSlug: null,
      template: null,
      loadTemplates: false
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.inputName, this.$refs.inputDescription]
    this.init()
  },
  methods: {
    init() {
      if (!this.loadTemplates) this.loadTemplates = true
      this.templateSelected(this.$route.query.template || '')
    },
    templateSelected(templateType) {
      const templateInfo = this.$refs.templateSelector.getInfo(templateType)
      this.template = templateInfo.type
      const name = this.$refs.inputName
      const desc = this.$refs.inputDescription
      if (name.data === '' || !name.init) name.setData(templateInfo.name)
      if (desc.data === '' || !desc.init) desc.setData(templateInfo.description)
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        // Call API
        let payload = {
          name: this.$refs.inputName.data,
          description: this.$refs.inputDescription.data
        }
        if (this.template) {
          payload.template = this.template
        }
        this.$store
          .dispatch('createLandscape', payload)
          .then(slug => {
            this.landscapeSlug = slug
            EventHub.emit(Events.CLOSE_SIDENAV)
            this.modalRef.submitSuccess()
          })
          .catch(error => {
            this.modalRef.submitFails(error.devMessage)
          })
      } else {
        this.modalRef.submitFails()
      }
    },
    cleanQuery() {
      this.$router.removeKeyFromQuery('template')
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        this.$router.push({
          name: 'info',
          params: {landscapeSlug: this.landscapeSlug}
        })
      }
    }
  }
}
</script>

<style>
.NewLandscape {
  .Modal-wrapper {
    width: 700px;
  }
}
</style>
